'use client';

import { ChangeEvent, useEffect, useState, FC } from 'react';
import { AddEntityTagFormProps } from './AddEntityTagForm.types';
import { Button, ButtonGroup, Flex, Input } from '@/_components';

export const AddEntityTagForm: FC<AddEntityTagFormProps> = ({
  onConfirm,
  onCancel,
}) => {
  const [entityTag, setEntityTag] = useState<string>('');

  const onCreate = () => {
    onConfirm(entityTag);
  };

  useEffect(() => {
    return () => setEntityTag('');
  }, []);

  const onChangeEntityTag = (event: ChangeEvent<HTMLInputElement>) =>
    setEntityTag(event.target.value);

  return (
    <Flex isColumn={true} gap={8}>
      <Input
        label="New Entity Tag"
        placeholder="Entity Tag"
        autoFocus={true}
        value={entityTag}
        onChange={onChangeEntityTag}
      />
      <ButtonGroup align="right">
        <Button intent="secondary" onClick={onCancel} value="Cancel" />
        <Button
          intent="primary"
          onClick={onCreate}
          value="Create Entity Tag"
          iconLeft="plus"
        />
      </ButtonGroup>
    </Flex>
  );
};
